import { API } from "@/services/swagger/resposeType"
import { setRemoteValue } from "@/utils/kv"
import {create} from "zustand"

export interface UserInfoProps {
    /** 是否登录 */
    isLogin: boolean
    /** 登录平台 */
    platform: string | null
    githubName: string | null
    githubHeadImg: string | null
    wechatName: string | null
    wechatHeadImg: string | null
    qqName: string | null
    qqHeadImg: string | null
    companyName: string | null
    companyHeadImg: string | null
    /** 角色 */
    role: string | null
    user_id: number | null
    token: string
    /** 是否有插件管理权限 */
    checkPlugin?: boolean
}
interface StoreProps {
    /**@name 登录用户信息 */
    userInfo: UserInfoProps
    setStoreUserInfo: (info: UserInfoProps) => void
}
export const useStore = create<StoreProps>((set, get) => ({
    userInfo: {
        isLogin: false,
        platform: null,
        githubName: null,
        githubHeadImg: null,
        wechatName: null,
        wechatHeadImg: null,
        qqName: null,
        qqHeadImg: null,
        companyName: null,
        companyHeadImg: null,
        role: null,
        user_id: null,
        token: "",
        checkPlugin: false
    },
    setStoreUserInfo: (info) => set({userInfo: info})
}))

export const setEeSystemConfig = (config: API.SystemConfigList[]) => {
    setRemoteValue("eeSystemConfig", JSON.stringify(config))
}
